/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";

type IBarValue = {
  color: string;
  value: number;
};

type IBarValues = {
  values: IBarValue[];
};

type IStyledBarProps = {
  height?: string;
  background?: string;
  centered?: boolean;
};

const StyledBarChart = styled.div`
  width: 100%;
  height: ${(props: IStyledBarProps) => props.height || "1.5rem"};
  background: ${(props: IStyledBarProps) => props.background || "transparent"};
  border-radius: 0.25rem;
  overflow: hidden;
  margin-bottom: ${(props: IStyledBarProps) =>
    props.centered ? "" : "0.5rem"};
  transform: ${(props: IStyledBarProps) =>
    props.centered ? "translateY(0.25rem)" : ""};
  display: flex;
`;

const StyledBar = styled.div`
  height: ${(props: IStyledBarProps) => props.height || "1.5rem"};
`;

type BarProps = IBarValues & IStyledBarProps;

export function BarChart({ values, ...visualProps }: BarProps) {
  const sum = values.reduce((s, { value }) => s + value, 0);
  const percentageValues = values.map(({ value, color }) => ({
    size: ((100 * value) / sum).toFixed(2),
    color,
  }));

  return (
    <StyledBarChart {...visualProps}>
      {percentageValues.map(({ size, color }) => (
        <StyledBar
          key={size + color}
          style={{ width: `${size}%`, background: color }}
          {...visualProps}
        />
      ))}
    </StyledBarChart>
  );
}
